<template>
  <section class="world-background">
    <cards-roulette :options="options" :type="'ebidta_sign'" />
  </section>
</template>

<script>
import FormQuestions from '@/constants/form_questions.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import enumeratesFormater from '@/mixins/enumeratesFormater.js'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'
import store from '@/store'

export default {
  components: { CardsRoulette },
  mixins: [enumeratesFormater, OnBoardStepMixin],
  beforeRouteEnter(to, from, next) {
    const phase2Data = store.getters['onBoard/neofintechData'].phase2
    const isNormalFlow = (from.name == 'onBoard.neofintech.phase2.3')
    const isException = phase2Data.sellsAmountRanges.includes('SAR00')
    if (isNormalFlow && isException) {
      next(vm => {
        store.commit('onBoard/SET_NEOFINTECH_EBIDTA_SIGN', ['FQES02'])
        store.commit('onBoard/SET_NEOFINTECH_EBIDTA_AMOUNT_RANGES', ['EAR00'])
        vm.$router.push({ name: 'onBoard.neofintech.phase2.6' })
      })
    } else {
      next()
    }
  },
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.options = this.tableDataToListFormat(FormQuestions.ebidtaSign)
  }
}
</script>
